import { renderNav } from '../components/nav.js';
import { renderMarkdown } from '../lib/markdown.js';
import faqSource from '../../../docs/faq.md?raw';

const FAQ_HTML = renderMarkdown(faqSource);

function bindInPageAnchors(root: HTMLElement, routePrefix: string): void {
  root.querySelectorAll('a').forEach((a) => {
    const href = a.getAttribute('href');
    if (href === null) return;
    if (!href.startsWith('#') || href.startsWith('#/')) return;
    const id = decodeURIComponent(href.slice(1));
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById(id);
      if (target !== null) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      window.history.replaceState(null, '', `${routePrefix}#${id}`);
    });
  });
}

function scrollToSection(section: string | null): void {
  if (section === null || section === '') return;
  requestAnimationFrame(() => {
    const el = document.getElementById(section);
    if (el !== null) el.scrollIntoView({ behavior: 'auto', block: 'start' });
  });
}

export function mountFaq(root: HTMLElement, section: string | null): () => void {
  root.innerHTML = `
    ${renderNav({ active: 'faq' })}
    <article class="faq-page">
      <div class="markdown-body">${FAQ_HTML}</div>
    </article>
  `;
  const article = root.querySelector<HTMLElement>('.faq-page');
  if (article !== null) bindInPageAnchors(article, '#/faq');
  scrollToSection(section);
  return () => {};
}
